import ResponsiveAppBar from "../../../layouts/navbar";
import CloseIcon from "@mui/icons-material/Close";
import { SearchAsync } from "../../../../app/slices/searchSlice/SearchSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/redux/hooks";
import { showSnackbar } from "../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { setSelectProduct } from "../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import CustomDialog from "../../../components/custom/dialog";
import { FilterProducts } from "../productListPage/components/filterProduct";
import { QuickAddModal } from "../productListPage/components/quickAdd/quickAdd";
import { CircularProgress } from "@mui/material";
import { getDecryptedToken } from "../../../../app/auth/authHandler";
import { getProductImageUrl } from "../../../../app/slices/common/imageConstants";

export const SearchResultPage = () => {
  const dispatch = useAppDispatch();
  const [serachTerm, setSearchTerm] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [modalType, setModalType] = useState("");
  const [filterParams, setfilterParams] = useState([]);
  const [filteredResults, setFilteredResults] = useState<any>([]);
  const [vegNonveg, setVegNonveg] = useState<string[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [dynamicFilters, setDynamicFiters] = useState<string[]>([]);
  const [priceRange, setPriceRange] = useState<[any, any]>([0, 5000]);
  const [isLoading, setIsLoading] = useState(true);

  const searchTextProps = useAppSelector(
    (state) => state.locationState.searchText
  );
  useEffect(() => {
    if (searchTextProps !== "") {
      setSearchTerm(searchTextProps);
      searchApiCall(searchTextProps);
    } else {
      setIsLoading(false);
    }
  }, [searchTextProps]);
  useEffect(() => {
    if (searchList) {
      setFilteredResults(searchList);
      priceAndVegnonVegFilter(searchList, priceRange, vegNonveg);
    } else {
      setIsLoading(false);
    }
  }, [searchList]);

  useEffect(() => {
    priceAndVegnonVegFilter(searchList, priceRange, vegNonveg);
  }, [priceRange, vegNonveg]);
  const priceAndVegnonVegFilter = (
    product: any,
    priceRange: number[],
    vegNonveg: string[]
  ) => {
    const filtered = product
      .map((subcategory: any) => {
        const filteredProducts = subcategory.products.filter((product: any) => {
          const price = parseFloat(product.price);
          const isInPriceRange =
            price >= priceRange[0] && price <= priceRange[1];
          const isTypeMatch =
            vegNonveg.length > 0
              ? vegNonveg.includes(product.product_type)
              : true;

          return isInPriceRange && isTypeMatch;
        });

        return {
          ...subcategory,
          products: filteredProducts,
        };
      })
      .filter((subcategory: any) => subcategory.products.length > 0);
    setFilteredResults(filtered);
  };

  useEffect(() => {
    searchApiCall(serachTerm);
  }, [dynamicFilters, tags]);

  const searchApiCall = async (searchTerm: any) => {
    if (searchTerm) setIsLoading(true);
    const aId = localStorage.getItem("aId");
    const accessToken = getDecryptedToken();
    const anonymous_id = accessToken ? null : aId || null;
    const hasFilters =
      (tags && tags.length > 0) ||
      (dynamicFilters && dynamicFilters.length > 0);

    if (hasFilters || searchTerm) {
      const payload: any = {
        category_code: searchTerm,
        ...(tags?.length && { tag_ids: tags }),
        ...(dynamicFilters?.length && { dynamic_filter_ids: dynamicFilters }),
        ...(anonymous_id && { anonymous_id }),
      };

      dispatch(SearchAsync(payload))
        .then((response: any) => {
          if (
            response?.payload?.status === 200 ||
            response?.payload?.status === 201
          ) {
            setSearchList(response?.payload?.data?.data || []);
            setfilterParams(response?.payload?.data?.filters || []);
            setIsLoading(false);
          } else {
            dispatch(
              showSnackbar({
                message: "Somthing went wrong, Please try again later.",
                severity: "error",
                autoHide: 2000,
              })
            );
          }
        })
        .catch((err: any) => {
          dispatch(
            showSnackbar({
              message: "Somthing went wrong, Please try again later.",
              severity: "error",
              autoHide: 2000,
            })
          );
        });
    }
  };
  const handleSort = (sortType: string) => {
    const sortedData = filteredResults?.map((subcategory: any) => {
      const sortedProducts = [...subcategory.products];

      switch (sortType) {
        case "alphabeticalAsc":
          sortedProducts.sort((a, b) =>
            a.product_name.localeCompare(b.product_name)
          );
          break;

        case "alphabeticalDesc":
          sortedProducts.sort((a, b) =>
            b.product_name.localeCompare(a.product_name)
          );
          break;

        case "priceAsc":
          sortedProducts.sort(
            (a, b) => parseFloat(a.price) - parseFloat(b.price)
          );
          break;

        case "priceDesc":
          sortedProducts.sort(
            (a, b) => parseFloat(b.price) - parseFloat(a.price)
          );
          break;

        default:
          break;
      }

      return {
        ...subcategory,
        products: sortedProducts,
      };
    });

    setFilteredResults(sortedData);
  };
  const selectProduct = (id: any) => {
    dispatch(setSelectProduct(id));
    localStorage.setItem("product_id", id);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      searchApiCall(serachTerm);
    }
  };
  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  const handleFilterChange = (filters: {
    priceRange: any;
    vegNonveg: string[];
    dynamicFilters: any[];
    tags: any[];
  }) => {
    const { priceRange, dynamicFilters, vegNonveg, tags } = filters;
    setPriceRange(priceRange);
    setDynamicFiters(dynamicFilters);
    setVegNonveg(vegNonveg);
    setTags(tags);
  };

  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />
        <section className="flat-spacing-1">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-8">
                <div id="sticky-anchor"></div>
                <div className="dropdown" id="sticky">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="searchInput"
                      placeholder="Search..."
                      autoComplete="off"
                      value={serachTerm}
                      onChange={(e: any) => setSearchTerm(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                    {serachTerm && (
                      <span
                        className="input-group-text"
                        id="clearIcon"
                        role="button"
                        onClick={(e: any) => setSearchTerm("")}
                      >
                        <i className="fas fa-times"></i>
                      </span>
                    )}

                    <span
                      className="input-group-text"
                      id="searchIcon"
                      role="button"
                      onClick={() => {
                        if (serachTerm!.length > 0) {
                          searchApiCall(serachTerm);
                        } else {
                          dispatch(
                            showSnackbar({
                              message: "Please enter search term",
                              severity: "error",
                              autoHide: 2000,
                            })
                          );
                        }
                      }}
                    >
                      <i className="icon-search"></i>
                      {/* <!-- <i className="fas fa-search"></i> Font Awesome fontawesome.com --> */}
                    </span>
                  </div>
                  <ul className="dropdown-menu w-100" id="dropdownMenu"></ul>
                </div>
              </div>
              {searchList.length > 0 && (
                <div className="tf-shop-control grid-2 align-items-center justify-content-between">
                  <div className="tf-control-filter">
                    <span
                      onClick={() => onOpenModal("filter")}
                      className="tf-btn-filter"
                    >
                      <span className="icon icon-filter"></span>
                      <span className="text">Filter</span>
                    </span>
                  </div>
                  <div className="tf-control-sorting d-flex justify-content-end">
                    <div className="tf-dropdown-sort" data-bs-toggle="dropdown">
                      <div className="btn-select">
                        <span className="text-sort-value">Sort By</span>
                        <span className="icon icon-arrow-down"></span>
                      </div>
                      <div className="dropdown-menu">
                        <div
                          className="select-item"
                          onClick={() => handleSort("alphabeticalAsc")}
                        >
                          <span className="text-value-item">
                            Alphabetically, A-Z
                          </span>
                        </div>
                        <div
                          className="select-item"
                          onClick={() => handleSort("alphabeticalDesc")}
                        >
                          <span className="text-value-item">
                            Alphabetically, Z-A
                          </span>
                        </div>

                        <div
                          className="select-item"
                          onClick={() => handleSort("priceAsc")}
                        >
                          <span className="text-value-item">
                            Price, low to high
                          </span>
                        </div>
                        <div
                          className="select-item"
                          onClick={() => handleSort("priceDesc")}
                        >
                          <span className="text-value-item">
                            Price, high to low
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div
                className="col-8 mt-4 p-0"
                style={{
                  fontFamily: "Albert Sans, sans-serif",
                  fontSize: "14px",
                  lineHeight: "22px",
                  fontWeight: 400,
                  color: "var(--main)",
                  backgroundColor: "var(--white)",
                }}
              >
                {isLoading ? (
                  <div className="row justify-content-between">
                    <div
                      className="tf-product-media-wrap sticky-top"
                      style={{ minHeight: "50vh" }}
                    >
                      <CircularProgress
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="row justify-content-between">
                      {filteredResults.length > 0 &&
                        filteredResults.map((item: any, index: any) => {
                          return (
                            <div key={index}>
                              <div className="flat-title">
                                <span
                                  className="title wow fadeInUp"
                                  data-wow-delay="0s"
                                >
                                  {item?.subcategory_name}{" "}
                                </span>
                              </div>
                              <div className="row" data-wow-delay="0s">
                                {item?.products
                                  ?.slice(0, 10)
                                  .map((product: any, index: number) => {
                                    return (
                                      <div
                                        className="col-md-6 mb-3"
                                        key={index}
                                      >
                                        <div
                                          className="card card-navya"
                                          style={{ padding: "10px" }}
                                        >
                                          <div className="row align-items-center">
                                            <div className="col-md-4 pe-0">
                                              <Link
                                                to={`/products/${product.product_id}`}
                                                className="title link"
                                              >
                                                <img
                                                  className="img-fluid w-100 rounded-start"
                                                  data-src={getProductImageUrl(product?.product_img)}
                                                  src={getProductImageUrl(product?.product_img)}
                                                  alt="image-product"
                                                  onClick={() =>
                                                    selectProduct(
                                                      product?.product_id
                                                    )
                                                  }
                                                />
                                              </Link>
                                            </div>
                                            <div className="col-md-8">
                                              <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center">
                                                  <Link
                                                    to={`/products/${product.product_id}`}
                                                    className="title link"
                                                  >
                                                    <div
                                                      className="card-product-info fs-16"
                                                      onClick={() =>
                                                        selectProduct(
                                                          product?.product_id
                                                        )
                                                      }
                                                    >
                                                      {product.product_name}
                                                    </div>
                                                  </Link>
                                                  <div className="variant-picker-item">
                                                    <div className="variant-picker-values">
                                                      <label
                                                        className={`hover-tooltip  ${
                                                          product?.product_type ===
                                                          "Veg"
                                                            ? "veg"
                                                            : "nonveg"
                                                        }`}
                                                        htmlFor="values-veg"
                                                        data-value="Veg"
                                                      >
                                                        <span
                                                          className={`btn-checkbox    ${
                                                            product?.product_type ===
                                                            "Veg"
                                                              ? "bg-color-veg bg-veg"
                                                              : "bg-color-nonveg "
                                                          }`}
                                                        ></span>
                                                        <span className="tooltip">
                                                          {product?.product_type ===
                                                          "Veg"
                                                            ? "Veg"
                                                            : "non-veg"}
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="tf-product-info-price mt-1">
                                                  <div className="price fs-14 fw-6">
                                                    ₹{product.price}
                                                  </div>
                                                  <div className="compare-at-price fs-14">
                                                    ₹{product.price}
                                                  </div>
                                                </div>

                                                <a
                                                  className="btn-prime mt-1"
                                                  onClick={() => {
                                                    selectProduct(
                                                      product?.product_id
                                                    );
                                                    onOpenModal("quickAdd");
                                                  }}
                                                >
                                                  Add to cart
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          );
                        })}

                      {/* 
                  <div className="col-md-6 mb-3">
                    <div
                      className="card card-navya "
                      style={{ padding: "10px" }}
                    >
                      <div className="row align-items-center">
                        <div className="col-md-4 pe-0">
                          <img
                            src="images/product01.png"
                            className="img-fluid rounded-start"
                            alt="Card Image"
                          />
                        </div>
                        <div className="col-md-8">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="card-product-info fs-16">
                                Blueberry Mimosa
                              </div>
                              <div className="variant-picker-item">
                                <div className="variant-picker-values">
                                 <label
                                    className="hover-tooltip veg"
                                    htmlFor="values-veg"
                                    data-value="Veg"
                                  >
                                    <span className="btn-checkbox bg-color-veg bg-veg"></span>
                                    <span className="tooltip">Veg</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="tf-product-info-price mt-1">
                              <div className="price fs-14 fw-6">₹57.00</div>
                              <div className="compare-at-price fs-14">
                                ₹60.0
                              </div>
                            </div>
                            <a href="#" className="btn-prime mt-1">
                              Add to Cart
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <CustomDialog
            component={
              <FilterProducts
                filterInputs={filterParams}
                onFilterChange={handleFilterChange}
              />
            }
            title="Filters"
            openDialog={modalType === "filter"}
            handleCloseDialog={onCloseModal}
            modalPlace="left"
          />
          {modalType === "quickAdd" &&  <CustomDialog
            component={<QuickAddModal modalType={modalType} />}
            title="Quick Add"
            openDialog={modalType === "quickAdd"}
            handleCloseDialog={onCloseModal}
            modalPlace="center"
          />}
        </section>
      </div>
    </>
  );
};
